<script setup lang="ts">
import ConsoleLogElement from './ConsoleLogElement.vue';
import { Log } from '@/logger';
import { ref, watch } from 'vue';

const { logs } = defineProps<{ logs: Array<Log> }>();
const console$ = ref<HTMLElement | null>(null);

watch(
  () => logs,
  () => {
    console$.value?.scrollTo(0, console$.value.scrollHeight);
  },
);
</script>

<template>
  <div ref="console$" class="console h-100">
    <ConsoleLogElement v-for="log in logs" :key="log.id" :log="log" />
  </div>
</template>

<style scoped>
.console {
  font-family:
    Consolas,
    Monaco,
    Lucida Console,
    Liberation Mono,
    DejaVu Sans Mono,
    Bitstream Vera Sans Mono,
    Courier New,
    monospace;
  background-color: black;
  color: white;
  overflow-y: auto;
  text-align: left;
  border-radius: 0.5em;
  padding: 1em;
  margin-top: 1em;
  max-height: 350px;
  width: 100%;

  pre {
    line-break: anywhere;
  }
}
</style>
